export function TypingIndicator({ label = 'typing' }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <div className="bg-slate-100 dark:bg-white/[0.06] rounded-2xl rounded-bl-sm px-3 py-2 flex items-center gap-1">
        <span className="support-typing-dot" />
        <span className="support-typing-dot" style={{ animationDelay: '150ms' }} />
        <span className="support-typing-dot" style={{ animationDelay: '300ms' }} />
      </div>
      <span>{label}</span>
      <style>{`
        .support-typing-dot{width:5px;height:5px;border-radius:9999px;background:currentColor;opacity:.5;display:inline-block;animation:support-typing 1s infinite ease-in-out}
        @keyframes support-typing{0%,60%,100%{transform:translateY(0);opacity:.4}30%{transform:translateY(-3px);opacity:1}}
      `}</style>
    </div>
  );
}
